module.exports = __webpack_public_path__ + "static/media/LSM_KDMSolu.a4ed71df.gif";